import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { tabIds } from 'legacy/src/components/questionBank/QuizBuilder/utils/constants';

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const AddQuestionsAction = forwardRef((props, ref) => {
  const { label, router, assessmentId, masterSubjectId, disabled } = props;
  return (
    <ButtonWithIcon
      isIcon
      isNaked
      icon="add_question"
      onClick={() =>
        router.push(
          `/${masterSubjectId}/question_bank/questions?quizId=${assessmentId}&activeTab=${tabIds.BROWSE}`,
        )
      }
      aria-label={label}
      tabIndex="0"
      innerRef={ref}
      disabled={disabled}
    />
  );
});

AddQuestionsAction.propTypes = {
  router: PropTypes.object.isRequired,
  assessmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  masterSubjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  label: PropTypes.string,
};

AddQuestionsAction.defaultProps = {
  label: '',
};

export default AddQuestionsAction;
